<template>
    <v-wait for="loading campaign units" class="layout column fill-height">
        <template slot="waiting">
            <vcl-list height="200"></vcl-list>
        </template>
        <v-card class="ma-1" v-for="campaign in groupedCampaigns" :key="campaign.campaignId">
            <v-list>
                <v-list-item>
                    <v-list-item-avatar class="mr-1">
                        <v-icon>departure_board</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title
                            class="subtitle-2"
                        >{{campaign.campaign.campaignNumber}}: {{campaign.campaign.campaignName}}
                        </v-list-item-title>
                        <v-list-item-subtitle>{{campaign.campaign.campaignTsbWpaReference}}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item
                    v-for="unit in campaign.units"
                    :key="unit.id"
                    :to="disabled || unit.isComplete ? {} : { query: { campaignUnitId: unit.id } }"
                    :class="classes(unit)"
                >
                    <v-list-item-content>
                        <v-list-item-title>
                            <unit-label :value="unit" class="ml-4"/>
                            <v-chip
                                v-if="unit.isPastDue"
                                class="mr-2"
                                label
                                small
                                color="red"
                                :dark="true"
                            >+{{unit.overdueDays}}
                            </v-chip>
                        </v-list-item-title>
                        <v-list-item-subtitle></v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                        <move-menu
                            :value="unit"
                            type="campaign"
                            v-if="!disabled && !unit.isComplete"
                            :max="unit.campaignMaxCompletionDate"
                            @move="moveCampaignToDate($event.service, $event.date)"
                        ></move-menu>
                    </v-list-item-action>
                </v-list-item>
            </v-list>
        </v-card>

        <div
            class="subtitle-1"
            v-if="!campaigns || campaigns.length == 0"
        >No campaigns to action today
        </div>
    </v-wait>
</template>
<script>
  import {VclList} from 'vue-content-loading';
  import {GarageLocationStore} from '@/stores/GarageLocationStore';
  import UnitLabel from '@/components/Units/UnitLabel.vue';
  import CampaignsClient from '@/components/Campaigns/CampaignClient.vue';
  import MoveMenu from '@/components/Calendar/Move/MoveMenu.vue';
  import Controls from './Controls.vue';
  import {Event} from '@/plugins/bus';
  import * as _ from 'lodash';

  export default {
    mixins: [Controls, CampaignsClient],
    components: {
      MoveMenu,
      VclList,
      UnitLabel
    },
    data() {
      return {
        campaigns: []
      };
    },
    computed: {
      querystring() {
        if (!this.params) {
          return '';
        }
        return (
          '?' +
          Object.keys(this.params)
            .filter(key => !!this.params[key])
            .map(key => key + '=' + this.params[key])
            .join('&')
        );
      },
      params() {
        return {
          from: this.from,
          to: this.to,
          garageLocationId: GarageLocationStore.data.userGarage
        };
      },
      disabled() {
        const g = GarageLocationStore.data.userGarage;
        const garages = GarageLocationStore.data.userGarages;
        return !this.userIsWorkshopManagerInGarage(g, garages) && !this.userIsFleetManager;
      },
      groupedCampaigns() {
        return _.chain(this.campaigns)
          .groupBy('campaignId')
          .map((value, key) => ({campaignId: key, campaign: value[0], units: value}))
          .value();
      }
    },
    async mounted() {
      await this.getCampaignData();
      this.$bus.$on(Event.GarageSelected, this.getCampaignData);
      this.$bus.$on(Event.CampaignUnitMoved, this.getCampaignData);
      this.$bus.$on(Event.CampaignCompleted, this.getCampaignData);
    },
    destroyed() {
      this.$bus.$off(Event.GarageSelected, this.getCampaignData);
      this.$bus.$off(Event.CampaignUnitMoved, this.getCampaignData);
      this.$bus.$off(Event.CampaignCompleted, this.getCampaignData);
    },
    watch: {
      async current(val) {
        await this.getCampaignData();
      },
      async userGarage(val) {
        await this.getCampaignData();
      }
    },
    methods: {
      async getCampaignData() {
        this.campaigns = await this.getCampaignUnits();
      },
      classes(unit) {
        return {
          'completed': !!unit.isComplete,
          'past-due': !unit.isComplete && unit.isPastDue
        };
      },
      async moveCampaignToDate(unit, date) {
        await this.moveCampaignUnit(unit, date);
      }
    }
  };
</script>
